import { render } from "./CheckoutPanel.vue?vue&type=template&id=bf6fddd8&scoped=true"
import script from "./CheckoutPanel.vue?vue&type=script&lang=js"
export * from "./CheckoutPanel.vue?vue&type=script&lang=js"

import "./CheckoutPanel.vue?vue&type=style&index=0&id=bf6fddd8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf6fddd8"]])

export default __exports__